import {
  Box,
  Checkbox,
  Divider,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  Typography,
} from "@mui/material";
import { useEffect, useState } from "react";
import DataTable from "../../common/dataTable";
import profileImage from "../../assets/images/profile.png";
import signatureImage from "../../assets/images/signature.png";
import PrimaryButton from "../../common/primaryButton";
import { useNavigate } from "react-router-dom";
import { setupFullscreenBlock } from "../../common/disableEscKey";
import RemainingTimeModal from "../liveTest/remainingTimeModal";
import commonActions from "../../Redux/common/actions";
import { useDispatch, useSelector } from "react-redux";
import { handleEncodeJson } from "../../utils/encodeDecodeJson";
import examActions from "../../Redux/exam/actions";
import SecondaryButton from "../../common/secondaryButton";
import checkAuth from "../../common/CheckAuth";
import dayjs from "dayjs";
import sampleTestActions from "../../Redux/sampleTest/actions";
import Cookies from "js-cookie";
import NotificationModal from "../../common/notificationModal";
import useFetchCandidateTokenDetails from "../../hooks/useFetchCandidateTokenDetails";
import { auditLog } from "../../utils/auditLog";

export default function Index() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { instructions, heartBeat, projectDetails } = useSelector(
    (state) => state.examReducer
  );
  const [candidateTokenDetails, setCandidateTokenDetails] = useState(null);
  const [checked, setChecked] = useState(false);
  const [showMore, setShowMore] = useState(false);

  const [showNotification, setShowNotification] = useState(false);
  const [timeToStart, setTimeToStart] = useState({
    hours: 0,
    minutes: 0,
    seconds: 0,
  });
  const [timeLeft, setTimeLeft] = useState({
    hours: 0,
    minutes: 0,
    seconds: 0,
  });
  const [triggeredMinutes, setTriggeredMinutes] = useState([]);
  const [selectedLanguage, setSelectedlanguage] = useState(null);
  const [value, setValue] = useState(1);
  const [isOnline, setIsOnline] = useState(navigator.onLine);

  let timeDuration = candidateTokenDetails?.configuration?.timeDuration;
  let timeDurationForScribe =
    candidateTokenDetails?.configuration?.timeDurationForScribe;
  timeDuration = String(timeDuration) || "00:00";
  timeDurationForScribe = String(timeDurationForScribe) || "00:00";
  let isScribe = candidateTokenDetails?.user?.scribeRequired;
  let hours = 0,
    minutes = 0;
  const isMultiday =
    candidateTokenDetails?.configuration?.startExamBetweenSpecifiedTime;
  let validTimeDuration = isScribe ? timeDurationForScribe : timeDuration;
  if (validTimeDuration.includes(":")) {
    [hours, minutes] = validTimeDuration.split(":").map(Number);
  } else {
    minutes = Number(validTimeDuration);
  }
  const totalMinutes = hours * 60 + minutes;
  const numberOfQuestions =
    candidateTokenDetails?.configuration?.numberOfQuestions;
  const formattedLanguages = candidateTokenDetails?.configuration?.languages
    .map((lang) => lang.charAt(0).toUpperCase() + lang.slice(1))
    .join(" / ");

  const formattedStartTime = dayjs(
    candidateTokenDetails?.configuration?.startTime
  )
    .subtract(5, "hour")
    .subtract(30, "minute")
    .format("hh:mm A");
  const formattedEndTime = dayjs(candidateTokenDetails?.configuration?.endTime)
    .subtract(5, "hour")
    .subtract(30, "minute")
    .format("hh:mm A");
  const timeRange = `${formattedStartTime} - ${formattedEndTime}`;

  const examEndTime = localStorage.getItem("examEndTime");
  const examEndDate = new Date(examEndTime);
  examEndDate.setTime(examEndDate.getTime() + (5 * 60 + 30) * 60 * 1000);
  let isMock = projectDetails?.mockMode;
  const updatedExamEndTime = isMock
    ? candidateTokenDetails?.configuration?.endTime
    : examEndDate.toISOString();
  const isLateLoginAllowed =
    candidateTokenDetails?.configuration?.lateLoginAllowed;
  useEffect(() => {
    if (!checkAuth(navigate)) return;
  }, []);
  useEffect(() => {
    if (!candidateTokenDetails?.configuration?.startTime) return;

    const startTime = new Date(candidateTokenDetails.configuration.startTime);

    const updateTimeToStart = () => {
      const now = new Date(heartBeat?.data);
      const difference = startTime - now;

      if (difference > 0) {
        const hours = Math.floor(difference / (1000 * 60 * 60));
        const minutes = Math.floor(
          (difference % (1000 * 60 * 60)) / (1000 * 60)
        );
        const seconds = Math.floor((difference % (1000 * 60)) / 1000);
        setTimeToStart({ hours, minutes, seconds });
      } else {
        if (!showNotification && difference <= 0) {
          dispatch({
            type: commonActions.SET_SHOW_MODAL,
            payload: { show: true, type: null, method: "N", data: null },
          });
          setShowNotification(true);
        }
        setTimeToStart({ hours: 0, minutes: 0, seconds: 0 });
      }
    };
    updateTimeToStart();
    const interval = setInterval(updateTimeToStart, 1000);

    return () => clearInterval(interval);
  }, [candidateTokenDetails, heartBeat]);

  useFetchCandidateTokenDetails({ setCandidateTokenDetails });

  useEffect(() => {
    dispatch({ type: examActions.GET_INSTRUCTIONS });
  }, []);
useEffect(() => {
  const isFullscreenAllowed = sessionStorage.getItem("candidate_exam_details"); // ya koi key

  if (isFullscreenAllowed) {
    const enterFullscreen = async () => {
      const elem = document.documentElement;

      try {
        if (elem.requestFullscreen) {
          await elem.requestFullscreen();
        } else if (elem.webkitRequestFullscreen) {
          await elem.webkitRequestFullscreen();
        } else if (elem.msRequestFullscreen) {
          await elem.msRequestFullscreen();
        }
      } catch (err) {
        console.warn("Fullscreen request failed:", err);
      }
    };

    enterFullscreen();
  }
}, [sessionStorage.getItem("candidate_exam_details")]);
  const handleChange = (language, newValue) => {
    setValue(newValue);
    setSelectedlanguage(language);
    auditLog({
      data: {
        RegistrationNumber: `${candidateTokenDetails?.user?.id}`,
        RollNumber: `${candidateTokenDetails?.user?.rollNo}`,
        Activity: `User selected ${language} Instruction language`,
        IPaddress: "",
      },
      dispatch,
      heartBeat,
    });
  };

  const filteredInstructions = instructions?.instructions?.filter(
    (instruction) => instruction.language === selectedLanguage
  );

  useEffect(() => {
    if (instructions?.instructions && instructions?.instructions[0]?.language) {
      setSelectedlanguage("english" || instructions?.instructions[0]?.language);
    }
  }, [instructions?.instructions]);

  const columns = [
    { id: "srno", label: "Sr. No." },
    { id: "testname", label: "Test Name" },
    { id: "noofquestion", label: "No. of Question" },
    { id: "language", label: "Language of paper" },
    { id: "duration", label: "Exam Duration" },
    { id: "time", label: "Time of Exam" },
  ];

  const mockColumns = [
    { id: "srno", label: "Sr. No." },
    { id: "testname", label: "Test Name" },
    { id: "noofquestion", label: "No. of Question" },
    { id: "language", label: "Language of paper" },
    { id: "duration", label: "Exam Duration" },
    { id: "time", label: "Time of Exam" },
    { id: "action", label: "Action" },
  ];

  const data = [
    {
      srno: 1,
      testname: "Computer Based Test",
      noofquestion: numberOfQuestions,
      language: formattedLanguages,
      duration: `${totalMinutes} mins`,
      time: timeRange,
    },
  ];

  const fontStyle = {
    fontSize: "12px",
    fontWeight: 500,
  };
  const fontStyleValue = {
    fontSize: "12px",
    fontWeight: 400,
  };
  const handleLiveTest = async () => {
    dispatch({
      type: commonActions.SET_SHOW_MODAL,
      payload: { show: false, type: null, method: "S", data: null },
    });
    auditLog({
      data: {
        RegistrationNumber: `${candidateTokenDetails?.user?.id}`,
        RollNumber: `${candidateTokenDetails?.user?.rollNo}`,
        Activity: "User selected Start Exam",
        IPaddress: "",
      },
      dispatch,
      heartBeat,
    });
    setupFullscreenBlock();
    await document.documentElement.requestFullscreen();
    sessionStorage.setItem("visitedQuestions", JSON.stringify(""));
    localStorage.setItem("examStartTime", heartBeat?.data);
    const formData = {
      imageSize: "L",
      language: selectedLanguage
        ? `${selectedLanguage}`
        : instructions?.instructions[0]?.language ||
        candidateTokenDetails?.configuration?.languages[0],
    };
    const encodedData = await handleEncodeJson({ encodeJSON: formData });
    dispatch({
      type: examActions.GET_EXAM_QUESTIONS,
      payload: {
        data: encodedData,
        formData: formData,
        navigate: navigate,
      },
    });
  };

  useEffect(() => {
    const handleOnline = () => setIsOnline(true);
    const handleOffline = () => setIsOnline(false);

    window.addEventListener("online", handleOnline);
    window.addEventListener("offline", handleOffline);

    return () => {
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("offline", handleOffline);
    };
  }, []);

  const handleMockTest = async () => {
    setupFullscreenBlock();
    await document.documentElement.requestFullscreen();
    const formData = {
      imageSize: "L",
      language: selectedLanguage
        ? `${selectedLanguage}`
        : instructions?.instructions[0]?.language ||
          candidateTokenDetails?.configuration?.languages[0],
    };
    const encodedData = await handleEncodeJson({ encodeJSON: formData });
    dispatch({
      type: examActions.GET_EXAM_QUESTIONS,
      payload: {
        data: encodedData,
        formData: formData,
        navigate: navigate,
        mockMode: projectDetails?.mockMode,
      },
    });
  };

  useEffect(() => {
    const startTime = Date.parse(
      candidateTokenDetails?.configuration?.startTime
    );
    const endTime = isLateLoginAllowed
      ? Date.parse(candidateTokenDetails?.configuration?.endTime)
      : Date.parse(
          updatedExamEndTime ?? candidateTokenDetails?.configuration?.endTime
        );
    const updateTimer = () => {
      const currentTime = new Date(heartBeat?.data);

      if (currentTime < startTime) {
        const totalDuration = endTime - startTime;
        const hours = Math.floor(totalDuration / (1000 * 60 * 60));
        const minutes = Math.floor(
          (totalDuration % (1000 * 60 * 60)) / (1000 * 60)
        );
        const totalSeconds = Math.floor(totalDuration / 1000);
        const seconds = totalSeconds % 60;
        setTimeLeft({ hours, minutes, seconds });
        return;
      }

      if (currentTime >= endTime) {
        setTimeLeft({ hours: 0, minutes: 0, seconds: 0 });
        return;
      }

      if (currentTime >= startTime) {
        const difference = endTime - currentTime;
        const hours = Math.floor(difference / (1000 * 60 * 60));
        const minutes = Math.floor(
          (difference % (1000 * 60 * 60)) / (1000 * 60)
        );
        const totalSeconds = Math.floor(difference / 1000);
        const seconds = totalSeconds % 60;
        setTimeLeft({ hours, minutes, seconds });
      }
    };

    updateTimer();
    const interval = setInterval(updateTimer, 1000);
    return () => clearInterval(interval);
  }, [candidateTokenDetails, heartBeat]);

  const handleSampleTest = async () => {
    dispatch({
      type: commonActions.SET_SHOW_MODAL,
      payload: { show: false, type: null, method: "S", data: null },
    });
    auditLog({
      data: {
        RegistrationNumber: `${candidateTokenDetails?.user?.id}`,
        RollNumber: `${candidateTokenDetails?.user?.rollNo}`,
        Activity: "User selected Sample Test",
        IPaddress: "",
      },
      dispatch,
      heartBeat,
    });
    setupFullscreenBlock();
    await document.documentElement.requestFullscreen();
    const formData = {
      imageSize: "L",
      language: selectedLanguage
        ? `${selectedLanguage}`
        : instructions?.instructions[0]?.language ||
          candidateTokenDetails?.configuration?.languages[0],
    };
    const encodedData = await handleEncodeJson({ encodeJSON: formData });
    dispatch({
      type: sampleTestActions.GET_SAMPLE_QUESTIONS,
      payload: {
        data: encodedData,
        formData: formData,
        navigate: navigate,
      },
    });
  };

  useEffect(() => {
    const notificationTimes =
      candidateTokenDetails?.configuration?.reminders || [];
    if (
      timeToStart?.hours === 0 &&
      timeToStart?.seconds === 0 &&
      candidateTokenDetails?.configuration &&
      candidateTokenDetails?.configuration?.reminders &&
      notificationTimes.includes(timeToStart?.minutes) &&
      !triggeredMinutes.includes(timeToStart?.minutes)
    ) {
      dispatch({
        type: commonActions.SET_ALERT,
        payload: {
          status: "success",
          show: true,
          message: `Exam starts in ${timeToStart?.minutes} minutes`,
        },
      });
      setTimeout(() => {
        dispatch({
          type: commonActions.SET_ALERT,
          payload: {
            status: null,
            show: false,
            message: null,
          },
        });
      }, 5000);
      setTriggeredMinutes((prev) => [...prev, timeToStart?.minutes]);
    }
  }, [timeToStart, candidateTokenDetails?.configuration?.reminders]);

  useEffect(() => {
    dispatch({
      type: examActions.GET_PROJECT_DETAILS,
      payload: {
        data: {
          project: `${Cookies.get("test_engine_project")}`,
        },
        navigate: navigate,
      },
    });
  }, []);

  let venue = sessionStorage.getItem("venue");

  useEffect(() => {
    dispatch({ type: examActions.GET_HEART_BEAT });
  }, []);

  const [isFullscreen, setIsFullscreen] = useState(false);

  useEffect(() => {
    const checkFullscreen = () => {
      setIsFullscreen(!!document.fullscreenElement);
    };

    checkFullscreen();

    document.addEventListener("fullscreenchange", checkFullscreen);

    return () => {
      document.removeEventListener("fullscreenchange", checkFullscreen);
    };
  }, []);

  return (
    <>
      <Grid
        container
        p={2}
        sx={{
          backgroundColor: "rgba(255, 255, 255, 1)",
          // height: venue && !isFullscreen ? "115vh" : "100vh",
          // minHeight: "100vh"
            minHeight: {
      xs: "100dvh",   // 🔥 mobile FIX
      md: "88vh",     // desktop unchanged
    },
    overflow: "hidden",
        }}
      >
        <Grid
          container
          p={1}
          sx={{
            border: "1px solid rgba(0, 0, 0, 0.2)",
            width: "100%",
            borderRadius: "8px",
            minHeight: { xs: "auto", md: "125px" },   // ← responsive & stable
            alignItems: "center",
          }}
        >
          <Grid item md={2}>
            <Grid sx={{ display: "flex", alignItems: "center", gap: "2px" }}>
              <Box sx={{ display: "flex", flexDirection: "column" }}>
                <Typography varient="caption" sx={{ fontSize: "10px", color: "#1E1E1E", fontWeight: "500" }}>
                  Photo uploaded
                </Typography>
                <Box
                  component={"img"}
                  src={
                    venue && !isMock
                      ? `${sessionStorage.getItem("api_url")}/${candidateTokenDetails?.user?.photoPath
                      }`
                      : projectDetails?.mockMode
                        ? profileImage
                        : candidateTokenDetails?.user?.photoPath
                  }
                  alt="profile image"
                  sx={{
                    height: { xs: "65px", sm: "80px", md: "93px" },
                    width: { xs: "52px", sm: "65px", md: "75px" },
                    border: "1px solid rgba(0, 0, 0, 0.2)",
                    objectFit: "cover",
                  }}

                />
              </Box>
            
              {/* {candidateTokenDetails?.configuration?.biometricMethod && (
                <Box sx={{ display: "flex", flexDirection: "column" }}>
                  <Typography varient="caption" sx={{ fontSize: "12px" }}>
                    Photo clicked
                  </Typography>
                  <Box
                    component={"img"}
                    src={candidateTokenDetails?.user?.photoPath}
                    alt="profile image"
                    sx={{ height: "97px", width: "auto" }}
                  />
                </Box>
              )} */}
            </Grid>
            
          </Grid>
          <Grid item xs={12} md={8}>
            <Grid container p={0.5} spacing={1}>

              {[
                ["Center name", candidateTokenDetails?.configuration?.venueName],
                [
                  "Enrollment no",
                  projectDetails?.mockMode
                    ? "12345"
                    : candidateTokenDetails?.user?.rollNo,
                ],
                [
                  "Name",
                  projectDetails?.mockMode
                    ? candidateTokenDetails?.candidate?.candidateName
                    : candidateTokenDetails?.user?.candidateName,
                ],
                ["Maximum Marks", candidateTokenDetails?.configuration?.maxMarks],
                [
                  "Exam Date",
                  dayjs(candidateTokenDetails?.configuration?.startTime).format(
                    "DD MMM, YYYY"
                  ),
                ],
                ["Exam Duration", `${totalMinutes} mins`],
                ["Exam Name", candidateTokenDetails?.configuration?.courseName],
                ["Exam Time", timeRange],
              ].map(([label, value], i) => (
                <Grid container item xs={12} md={6} key={i}>
                  <Grid item xs={6}>
                    <Typography style={fontStyle}><b>{label}</b></Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <Typography style={fontStyleValue}>: {value}</Typography>
                  </Grid>
                </Grid>
              ))}

            </Grid>
          </Grid>

          <Divider orientation="vertical"
            flexItem
            sx={{ display: { xs: "none", md: "block" } }} />

          <Grid
            item
            xs={12}
            md={1.8}
            p={{ xs: 0, md: 4 }}
            pt={{ xs: 0, md: 1.5 }}
            pb={{ xs: 0, md: 1.5 }}
            display="flex"
            flexDirection="column"
            justifyContent="center"
            alignItems="center"
            sx={{
              mt: { xs: 0, md: 0 }
            }}
          >
            <Box
              sx={{
                minHeight: { xs: "30px", sm: "60px" },
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                textAlign: "center",
              }}
            >
              {timeToStart?.hours === 0 &&
                timeToStart?.minutes === 0 &&
                timeToStart?.seconds === 0 ? (
                <Typography
                  sx={{
                    color: "rgba(63, 65, 209, 1)",
                    fontWeight: "bold",
                    fontSize: { xs: "14px", md: "16px" },
                  }}
                >
                  <b>Exam Started</b>
                </Typography>
              ) : (
                <>
                  <Typography sx={{ ...fontStyle, fontSize: { xs: "12px", md: "14px" } }}>
                    <b>Exam Starts in</b>
                  </Typography>
                  <Typography sx={{ fontSize: { xs: "16px", md: "20px" } }}>
                    <b>
                      {String(timeToStart?.hours).padStart(2, "0")}:
                      {String(timeToStart?.minutes).padStart(2, "0")}:
                      {String(timeToStart?.seconds).padStart(2, "0")}
                    </b>
                  </Typography>
                </>
              )}
            </Box>
          </Grid>
        </Grid>
        <Grid
          item
          xs={12}
          mt={1}
          p={{ xs: 1, md: 1 }}
          sx={{
            backgroundColor: "rgba(240, 240, 251, 1)",
            minHeight: "42px",
            width: "100%",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            gap: { xs: 1, sm: 0 },
            borderRadius: "8px",
          }}
        >
          {/* Left Heading */}
          <Box>
            <Typography
              sx={{
                color: "rgba(63, 65, 209, 1)",
                fontSize: { xs: "14px", md: "16px" },
                fontWeight: "bold",
              }}
            >
              Instruction
            </Typography>
          </Box>

          {/* Right Box — Language Selector */}
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "flex-end",
              width: { xs: "80%", sm: "25%" },
              gap: "6px",
            }}
          >
            <Typography
              sx={{
                color: "#000",
                fontSize: { xs: "11px", sm: "12px"},
                textWrap: "nowrap",
              }}
            >
              Language 
            </Typography>
            <FormControl size="small" >
              <InputLabel></InputLabel>
              <Select
                size="small"
                onChange={(event) => handleChange(event.target.value, 0)}
                value={selectedLanguage}
                sx={{ height: "28px", fontSize: { xs: "12px", sm: "14px" }, background: "#fff" }}
              >
                {instructions?.instructions?.map((instruction, index) => (
                  <MenuItem
                    sx={{ textTransform: "capitalize" }}
                    key={index}
                    value={instruction?.language}
                  >
                    {instruction.language.charAt(0).toUpperCase() +
                      instruction.language.slice(1)}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Box>
        </Grid>

        {/* ---------------- INSTRUCTIONS SCROLL BOX ---------------- */}

        <Grid
          item
          xs={12}
          md={12}
          sx={{
            lineHeight: "20px",
            maxHeight: { xs: "300px", md: "375px" },
            ml: 0,
            overflowY: "scroll",
            px: { xs: 1, md: 0 },
            "&::-webkit-scrollbar": {
              width: "8px",
              height: "8px",
            },
            "& p": {
             margin: { xs: "6px 0", md: "1rem" },
            },
            "&::-webkit-scrollbar-track": {
              background: "#e0e0e0",
              borderRadius: "10px",
            },
            "&::-webkit-scrollbar-thumb": {
              background: "blue",
              borderRadius: "10px",
              border: "2px solid #e0e0e0",
              height: "10px",
            },
            "&::-webkit-scrollbar-thumb:hover": {
              background: "darkblue",
            },
          }}
        >
          {filteredInstructions?.map((instruction, index) => (
            <Box value={value} index={index} key={index}>
              <Grid
                className="grid-container"
                p={{ xs: 0.3, md: 1 }}
                sx={{ fontSize: { xs: 12, md: 13 } }}
                dangerouslySetInnerHTML={{
                  __html: instruction?.value,
                }}
              />
            </Box>
          ))}
        </Grid>

        {/* ---------------- MOCK EXAM SECTION ---------------- */}

        {projectDetails?.mockMode && (
          <>
            <Typography
              mt={2}
              sx={{
                color: "rgba(63, 65, 209, 1)",
                fontSize: { xs: "14px", md: "16px" },
                fontWeight: 500,
              }}
            >
              About Mock Exam
            </Typography>
            <Grid item md={12} pt={2} pb={2}>
              <DataTable
                columns={mockColumns}
                data={data}
                name={"mocktest"}
                handleMockTest={handleMockTest}
              />
            </Grid>
          </>
        )}

        {/* ---------------- TERMS & CONDITIONS + CHECKBOX ---------------- */}

        {!projectDetails?.mockMode && (
          <>
            <Grid item xs={12} pt={1}>
              <Divider sx={{ width: "100%" }} />
            </Grid>
            <Grid
              item
              xs={12}
              pt={1}
              sx={{
                display: "flex",
                gap: { xs: 1, sm: 2 },
                alignItems: { xs: "flex-start", sm: "center" },
                px: { xs: 1, sm: 0 },      // ← adds spacing on mobile
              }}
            >
              <Checkbox
                checked={checked}
                onChange={() => {
                  setChecked(!checked);
                  auditLog({
                    data: {
                      RegistrationNumber: `${candidateTokenDetails?.user?.id}`,
                      RollNumber: `${candidateTokenDetails?.user?.rollNo}`,
                      Activity: "User selected check box of Terms and conditions",
                      IPaddress: "",
                    },
                    dispatch,
                    heartBeat,
                  });
                }}
                sx={{
                  height: "20px",
                  width: "20px",
                  mt: { xs: 0.5, sm: 0 }, // aligns vertically on mobile
                  flexShrink: 0,          // prevents checkbox from resizing
                }}
                color="success"
              />

              <Typography
                sx={{
                  fontSize: { xs: "12px", md: "13px" },
                  lineHeight: "20px",
                  pr: { xs: 1, sm: 0 },
                }}
              >
                I have read and understand instructions. All computer hardware
                allotted to me are in proper working condition.

                {!showMore && (
                  <span
                    style={{
                      color: "#3f41d1",
                      cursor: "pointer",
                      marginLeft: "6px",
                      fontWeight: 500,
                    }}
                    onClick={() => setShowMore(true)}
                  >
                    Read more
                  </span>
                )}

                {showMore && (
                  <>
                    <br />
                    I declare that I am not possession of / not wearing / not carrying
                    any prohibited gadget like mobile phone, blue tooth device etc. /
                    any prohibited material with me into the Examination Hall.
                    <br />
                    I agree that in case of not adhering to the instructions, I shall be
                    liable to debarred from this test and / or disciplinary action.
                    <br />

                    <span
                      style={{
                        color: "#3f41d1",
                        cursor: "pointer",
                        fontWeight: 500,
                      }}
                      onClick={() => setShowMore(false)}
                    >
                      Read less
                    </span>
                  </>
                )}
              </Typography>

            </Grid>

            {/* ---------------- BUTTONS ---------------- */}

            <Grid
              item
              xs={12}
              pt={3}
              sx={{
                display: "flex",
                flexDirection: { xs: "column", sm: "row" },
                gap: "12px",
                alignItems: { xs: "center", sm: "flex-start" },
                px: { xs: 1, sm: 0 },
              }}
            >
              {candidateTokenDetails?.configuration?.sampleTestRequired && (
                <SecondaryButton
                  color={"rgba(63, 65, 209, 1)"}
                  border="1px solid rgba(63, 65, 209, 1)"
                  width={{ xs: "100%", sm: "150px" }}
                  onClick={() => handleSampleTest()}
                >
                  Sample Test
                </SecondaryButton>
              )}
              <PrimaryButton
                onClick={handleLiveTest}
                width={{ xs: "100%", sm: "150px" }}
                padding={{ xs: "10px", sm: "2px" }}
                disabled={
                  timeLeft?.hours === 0 &&
                  timeLeft?.minutes === 0 &&
                  timeLeft?.seconds === 0 &&
                  timeToStart?.hours === 0 &&
                  timeToStart?.minutes === 0 &&
                  timeToStart?.seconds === 0 &&
                  checked
                    ? false
                    : timeToStart?.hours === 0 &&
                      timeToStart?.minutes === 0 &&
                      timeToStart?.seconds === 0 &&
                      checked
                    ? false
                    : true
                }
                borderRadius={"138px"}
                color={"#000"}
              >
                start live exam
              </PrimaryButton>
            </Grid>
          </>
        )}
      </Grid>
      <RemainingTimeModal
        endExamMinutes={0}
        startExamMinutes={timeToStart?.minutes}
      />
      {!isMultiday && <NotificationModal />}
    </>
  );
}
